import Image from '@/components/UI/Image';
import { handleMultiProductImages } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function Multi3Spec({ theme, productCatagoryData, p1, p2, p3 }: any) {
    const { isMobile, useState, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [arr, setArr] = useState([p1, p2, p3]);
    const [newArr, setNewArr] = useState(isMobile ? arr.slice(0, arr.length - 1) : arr);
    const [active, setActive] = useState(0);

    // console.log('--productCatagoryData', JSON.stringify(productCatagoryData[2].specParamList));
    // console.log('--productCatagoryData', productCatagoryData);

    useEffect(() => {
        // 0529  ZA 的river2 不展示rive2pro
        setArr([p1, p2, p3]);
        // console.log('p1', p1);
        setNewArr(isMobile ? [p1, p2] : [p1, p2, p3]);
    }, [p1, p2, p3]);

    const formatImg = (productDetail: any) => {
        const imgObj = JSON.parse(typeof productDetail?.images === 'string' ? productDetail?.images : JSON.stringify(productDetail?.images) || '{}');
        let skuListData: any;
        if (productDetail?.skuList?.length > 0) {
            skuListData = productDetail.skuList;
        } else {
            skuListData = [
                {
                    images: handleMultiProductImages(productDetail?.images, 'specs'),
                    name: productDetail?.name,
                },
            ];
        }
        // 三列产品的特殊情况： 优先使用transparentImg
        return imgObj?.transparentImages || imgObj?.spaceImages || imgObj?.images || skuListData[0]?.images;
    };

    const generateSpecValue = (product: any, group: any, param: any) => {
        const ownSpec = product && product.skuList && product.skuList?.length && product?.skuList[0]?.ownSpec;
        const ownSpecObj = JSON.parse(typeof ownSpec === 'string' ? ownSpec : JSON.stringify(ownSpec) || '{}');
        const ownSpecGroup = ownSpecObj[group?.specGroupId];
        const ownSpecGroupObj = JSON.parse(typeof ownSpecGroup === 'string' ? ownSpecGroup : JSON.stringify(ownSpecGroup) || '{}');
        let specV = ownSpecGroupObj[param?.specParamId];
        if (param?.fieldType === 'boolean') {
            const v = !specV ? '-' : ['false'].includes(specV) ? '-' : '✓';
            return v;
        }
        if (!Number.isNaN(Number(specV))) {
            specV = specV + (param?.unit || '');
        }
        return specV || '-';
    };

    let startX = 0;
    // 开始移动
    const onStart = (e: any) => {
        if (isMobile) {
            startX = e.targetTouches[0].clientX;
        }
    };

    //移动结束： 修正偏移状态
    const onEnd = (e: any) => {
        if (isMobile) {
            const moveX = e?.changedTouches[0]?.clientX;
            e.currentTarget.style.transition = 'left 0.3s ease';
            // 第一列且右滑
            if (moveX < startX && active === 0) {
                e.currentTarget.style.left = locale === 'sa' ? '50vw' : `-50vw`;
                setActive(1);
                setNewArr([p2, p3]);
            }
            // 第二列且左滑
            if (moveX > startX && active === 1) {
                e.currentTarget.style.left = `0`;
                setActive(0);
                setNewArr([p1, p2]);
            }
        }
    };

    return (
        <div className={`multi_3_spec ${css.multi_3_spec} ${isMobile ? 'multi_3_spec_h5' : 'multi_3_spec_pc'} ${theme === 'black' ? 'black' : 'white'}`}>
            <div className="innerBox">
                {/* 上半部分：图片 */}
                <div className="upperBox">
                    <ul className={`upper ${arr?.length < 3 ? 'around' : ''}`} onTouchStart={onStart} onTouchEnd={onEnd}>
                        {arr.map((productDetail: any, index: number) => (
                            <li className="pUpperList" key={(productDetail?.spuId || '') + index}>
                                <p className="pName">{productDetail?.name}</p>
                                <p className="pImg">
                                    <Image
                                        src={formatImg(productDetail)}
                                        className="containImg"
                                        layout="fill"
                                        alt={productDetail?.name}
                                        aria-label={productDetail?.name}
                                    />
                                </p>
                            </li>
                        ))}
                    </ul>
                    {isMobile && newArr?.length > 2 && (
                        <div className="pagination">
                            {newArr?.map((_: any, k: number) => (
                                <div className={`dot ${active === k ? 'active' : ''}`} key={k}></div>
                            ))}
                        </div>
                    )}
                </div>
                {/* 下半部分：规格参数 */}
                <ul className="supper">
                    {productCatagoryData?.map((group: any, k: number) => (
                        <li className="groupsList" key={group?.specGroupId + k}>
                            <p className="groupName">{group?.name}</p>
                            <table className="pLists">
                                <tbody>
                                    {group?.newSpecparamList?.map((param: any, m: number) => (
                                        <tr className="pList" key={m}>
                                            {newArr?.map((product: any, n: number) => {
                                                const specV = generateSpecValue(product, group, param);
                                                // flag: me-ar 全局direction: rlt了，但是spec中并不是所有的需要revert
                                                const flag = locale === 'sa' && String(specV).endsWith(' [* *]');
                                                return (
                                                    <td className={`paramList param_${k}_${n}`} key={n}>
                                                        <p className="specName">{param?.name}</p>
                                                        <p className={`specValue ${flag ? 'ltr' : ''}`}>{flag ? String(specV).split(' [* *]')[0] : specV}</p>
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
